export default __webpack_public_path__ + "static/media/data3.788ed38b.svg";